import { useSearchParams } from 'react-router-dom';
import {
  DEFAULT_AFTER_LOGIN,
  NEXT_PARAM,
  safeNextPath
} from '../utils/login-return';

/**
 * Where the login page sends a customer once signed in: the same-site `next` path a link
 * that needed sign-in carried (an email's transaction, a printed receipt), else home.
 */
export const useLoginReturnPath = (): string => {
  const [searchParams] = useSearchParams();
  return safeNextPath(searchParams.get(NEXT_PARAM)) ?? DEFAULT_AFTER_LOGIN;
};
